import React from 'react'

function TeamFour() {
    return (
        <div>
            {/* rts team area start */}
            <div className="rts-team-area rts-section-gap rts-team-bg-home-7">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center home-six-team">
                                <p className="pre-title">Team Members</p>
                                <h2 className="title">Meet Our Dedicated Team</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--10">
                        {/* single teaam area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-single-team-h7 six">
                                <div className="social-area">
                                    <ul className="social-wrapper">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-instagram" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="thumbnail">
                                    <img src="assets/images/team/tm/14.jpg" alt="" />
                                </div>
                                <div className="content">
                                    <a href="#">
                                        <h5 className="title">Andreas Menor</h5>
                                    </a>
                                    <span className="desig">Sr. Manager</span>
                                </div>
                            </div>
                        </div>
                        {/* single teaam area end */}
                        {/* single teaam area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-single-team-h7 six">
                                <div className="social-area">
                                    <ul className="social-wrapper">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-instagram" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="thumbnail">
                                    <img src="assets/images/team/tm/15.jpg" alt="" />
                                </div>
                                <div className="content">
                                    <a href="#">
                                        <h5 className="title">Andreas Menor</h5>
                                    </a>
                                    <span className="desig">Sr. Manager</span>
                                </div>
                            </div>
                        </div>
                        {/* single teaam area end */}
                        {/* single teaam area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-single-team-h7 six">
                                <div className="social-area">
                                    <ul className="social-wrapper">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-instagram" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="thumbnail">
                                    <img src="assets/images/team/tm/16.jpg" alt="" />
                                </div>
                                <div className="content">
                                    <a href="#">
                                        <h5 className="title">Andreas Menor</h5>
                                    </a>
                                    <span className="desig">Sr. Manager</span>
                                </div>
                            </div>
                        </div>
                        {/* single teaam area end */}
                        {/* single teaam area start */}
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-single-team-h7 six">
                                <div className="social-area">
                                    <ul className="social-wrapper">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-instagram" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="thumbnail">
                                    <img src="assets/images/team/tm/17.jpg" alt="" />
                                </div>
                                <div className="content">
                                    <a href="#">
                                        <h5 className="title">Andreas Menor</h5>
                                    </a>
                                    <span className="desig">Sr. Manager</span>
                                </div>
                            </div>
                        </div>
                        {/* single teaam area end */}
                    </div>
                </div>
            </div>
            {/* rts team area end */}
        </div>
    )
}

export default TeamFour